import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { api } from "../../environments/environment";
import { Message, RestService } from "@stdoutsrl/design-kit";
import { LoaderService } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-example-monouse-component",
  template: ``,
  styles: [],
  standalone: false,
})
export class DetailOperatorComponent implements OnInit {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;
  listOfService: any = [];
  operator: any = {};
  formData = new FormData();
  listOfSelectedServices: any[] = [];
  api = api;

  constructor(
    private host: ElementRef<HTMLElement>,
    private rest: RestService,
    private loader: LoaderService,
    private message:Message
  ) {}

  ngOnInit(): void {
   
    window.location.replace('operatore/'+ this.fatherElement.id)
   this.autoDestory()
  }


  autoDestory() {
    this.host.nativeElement.remove();
  }
}
